export type WebMcpToolsPolicy = "allowed" | "blocked" | "unknown";

export type WebMcpPreflightInput = {
  readonly secureContext: boolean;
  readonly topLevelContext: boolean;
  readonly modelContextAvailable: boolean;
  readonly registerToolAvailable: boolean;
  readonly toolsPolicy: WebMcpToolsPolicy;
};

export type WebMcpPreflightSnapshot = WebMcpPreflightInput & {
  readonly status: "ready_for_inspector" | "blocked" | "unsupported";
  readonly blockedReason:
    | "none"
    | "insecure_context"
    | "not_top_level"
    | "tools_policy_blocked"
    | "model_context_unavailable"
    | "register_tool_unavailable";
  readonly registrationPerformed: false;
};

export function buildWebMcpPreflightSnapshot(input: WebMcpPreflightInput): WebMcpPreflightSnapshot {
  let status: WebMcpPreflightSnapshot["status"] = "ready_for_inspector";
  let blockedReason: WebMcpPreflightSnapshot["blockedReason"] = "none";

  if (!input.secureContext) {
    status = "blocked";
    blockedReason = "insecure_context";
  } else if (!input.topLevelContext) {
    status = "blocked";
    blockedReason = "not_top_level";
  } else if (input.toolsPolicy === "blocked") {
    status = "blocked";
    blockedReason = "tools_policy_blocked";
  } else if (!input.modelContextAvailable) {
    status = "unsupported";
    blockedReason = "model_context_unavailable";
  } else if (!input.registerToolAvailable) {
    status = "unsupported";
    blockedReason = "register_tool_unavailable";
  }

  return {
    ...input,
    status,
    blockedReason,
    registrationPerformed: false,
  };
}
